// extracted by mini-css-extract-plugin
module.exports = {"form":"UserChangePassword_form__3t8v8","input":"UserChangePassword_input__1HDex","buttonCancel":"UserChangePassword_buttonCancel__GBGxW"};